export const verification = {
    title: 'Identity verification',
    infomation: 'Personal information.',
    content:
        'Please make sure that all information entered matches your identification. You cannot change the information after you press confirm.',
    selectInfo: 'Select the type of identification document.',
    passport: 'passport',
    identity: 'citizen identification card',
    countries: 'Select country',
    numberCmt: 'Citizen identification number',
    numberPassport: 'Passport number',
    identityTitle: 'ID card photo.',
    passportTitle: 'Passport photo.',
    line1: 'Please make sure that the photo of your ID is clear and detailed.',
    line2: 'Please use images up to 10MB in size',
    line3: 'Please use images in JPG, JPEG, PNG.',
    label1: 'Enough details.',
    label2: 'Must not be missing',
    label3: 'Not blurred',
    label4: 'Not shadowed',
    contentBefore: 'Upload Front side',
    contentAfter: 'Upload back side',
    imageBefore: 'Front side',
    imageAfter: 'Back side',
    passportLabel: 'Passport photo',
    portraitLabel: 'Portrait',
    back: 'Back',
    nextStep: 'Next',
    portraitTitle: 'Self-portrait.',
    portraitContent1: 'Please do not wear hats, glasses or use filters, enough light. ',
    portraitContent2: 'Please use images up to 10MB in size. ',
    portraitContent3: 'Please use images in JPG, JPEG, PNG.',
    portraitContent4Cccd:
        'Take a clear photo of your face with your ID card held in your hand and a piece of paper with the date taken and write "ste.sbgroup.finance".',
    portraitContent4Passport:
        'Take a clear photo of your face with your passport held in your hand and a piece of paper with the date taken and write "ste.sbgroup.finance.',
    contentPortrait: 'Upload your image',
    completeTitle: 'Thanks for verifying your identity!',
    completeContent: 'Please wait for the Admin to verify before purchasing',
    gotoHome: 'Go to Home',
    requiredImage: 'Cannot be left blank',
    required: {
        passportLabel: 'Passport photo cannot be left blank',
        portraitLabel: 'Portrait cannot be left blank',
        imageBefore: 'Front side cannot be left blank',
        imageAfter: 'Back side cannot be left blank',
    },
    validateMaxSizeImage: 'Only upload files under 10MB',
    validateMinSizeImage: 'Photos must be at least 10kb in size',
    validateImage: 'Only jpg,png.jpeg images can be uploaded',
    placeholderCmt: 'E.G: B2412111',
};
